/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PatchCollaborationToolTemplateRequestDto = {
    type: PatchCollaborationToolTemplateRequestDto.type;
};

export namespace PatchCollaborationToolTemplateRequestDto {

    export enum type {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
